import { FileIcon } from './FileIcon'
import { featuredCards } from '@/utils/data'
import styles from './FeaturedCards.module.css'

export function FeaturedCards() {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>For you</h2>
      <div className={styles.grid}>
        {featuredCards.map((card) => (
          <div key={card.id} className={styles.card}>
            <div className={styles.cardHeader}>
              <FileIcon type={card.fileType} size="sm" />
              <span className={styles.cardTitle}>{card.name}</span>
            </div>
            <div className={styles.cardBody}>
              <div className={styles.cardMeta}>
                <div className={styles.metaRow}>
                  <span className={styles.metaDot} />
                  <span className={styles.metaDesc}>{card.description}</span>
                </div>
                <span className={styles.metaTime}>{card.timestamp}</span>
              </div>
              {card.previewImage ? (
                <img
                  src={card.previewImage}
                  alt={card.name}
                  className={styles.previewImg}
                />
              ) : card.hasPreview ? (
                <div
                  className={styles.preview}
                  style={{ background: card.previewColor }}
                >
                  <PreviewLines color={card.previewColor} />
                </div>
              ) : (
                <div className={styles.previewEmpty}>
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" className={styles.previewEmptyIcon}>
                    <rect x="6" y="2" width="20" height="28" rx="2" fill="#e1dfdd" />
                    <rect x="10" y="10" width="12" height="2" rx="1" fill="#a19f9d" />
                    <rect x="10" y="14" width="12" height="2" rx="1" fill="#a19f9d" />
                    <rect x="10" y="18" width="8" height="2" rx="1" fill="#a19f9d" />
                  </svg>
                </div>
              )}
            </div>
            <div className={styles.cardFooter}>
              <button className={styles.openBtn}>Open</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

function PreviewLines({ color }: { color?: string }) {
  const isDark = color === '#fff9c4'
  const lineColor = isDark ? 'rgba(0,0,0,0.12)' : 'rgba(100,120,200,0.15)'
  return (
    <div className={styles.previewLines}>
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className={styles.previewLine}
          style={{
            background: lineColor,
            width: `${70 + Math.random() * 30}%`,
          }}
        />
      ))}
    </div>
  )
}
